import {Mutex} from 'async-mutex'
import axios, {AxiosStatic} from 'axios'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import AuthRedux from 'src/app/store/Auth/AuthRedux'

const mutex = new Mutex()
const plainAxios = axios.create()

dayjs.extend(utc)
dayjs.extend(timezone)

export default function setupAxios(localAxios: AxiosStatic, store: any) {
  localAxios.defaults.baseURL = process.env.REACT_APP_API_URL
  plainAxios.defaults.baseURL = process.env.REACT_APP_API_URL

  localAxios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken},
      } = store.getState()

      if (accessToken && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      config.headers['Accept-Language'] = 'id,en-US;q=0.9,en;q=0.8'
      config.headers['X-OpteraOne-Timezone'] = dayjs.tz.guess()

      return config
    },
    (err: any) => {
      Promise.reject(err)
    }
  )
  localAxios.interceptors.response.use(
    (response: any) => response,
    async (error: any) => {
      const {
        auth: {refreshtoken},
      } = store.getState()
      const {dispatch} = store

      const {status} = error.response ?? {}
      if (status === 401 && refreshtoken) {
        return mutex.runExclusive(async () => {
          const refresh = await _refreshToken(refreshtoken)

          if (refresh) {
            error.config.headers.Authorization = `Bearer ${store.getState().auth.accessToken}`
            try {
              return await plainAxios.request(error.config)
            } catch (err: any) {
              if (err.response?.status === 401) dispatch(AuthRedux.actions.setSessionEnded(true))
              throw err
            }
          }
          dispatch(AuthRedux.actions.setSessionEnded(true))
          throw error
        })
      }
      throw error
    }
  )
  const _refreshToken = async (refreshtoken: any) => {
    const {dispatch} = store
    try {
      const result = await plainAxios.post(`/api/v1/admins/users/refresh-token`, null, {
        headers: {
          Authorization: `Bearer ${refreshtoken}`,
          'Accept-Language': 'id,en-US;q=0.9,en;q=0.8',
        },
      })
      if (result.data)
        dispatch(
          AuthRedux.actions.fulfillToken({
            token: result.data.response_output?.detail.token,
            refreshtoken: result.data.response_output?.detail.refresh_token,
          })
        )
      return result.data
    } catch (error) {
      dispatch(AuthRedux.actions.setSessionEnded(true))
      throw error
    }
  }
}
